<template>
  <div class="modal-backdrop">
    <div class="card col-lg-4 col-md-8 mt-md-4 col-11 p-0 mx-auto" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2 text-center pointer" id="exampleModalLabel"  @click="NavigateToBack"><img src="../assets/Back.svg" v-if="addingNewLink" class="negmargin5 mr-2 pointer" height="20px" alt="back"/>Links</h5>          
          <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="line"></div>
        <div class="modal-body bodymodal11" v-if="!addingNewLink">
          <div class="p-3">
            <div class="row opacityfont-12 pb-3" >
                <button class="borderblack60 mb-3 backgroundnone proximanova-semibold black col-12 mt-3 mx-auto p-2 borderradius20 fontsize14" @click="AddNewBadge">Add New Links</button>
                <div class="col-12 pl-0 pr-0 mt-2" v-for="(savedlink, index) in userLinksList" :key="index">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex">
                        <img :src="require('../assets/userlinks_'+savedlink.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                        <span class="borderblack60 pl-3 pr-3 pointer p-1 my-auto borderradius20 fontsize12 proximanova-semibold col-12 pl-0 pr-0">{{savedlink.userLinks.url}}</span>
                      </div>
                      <img src="../assets/white_close_btn.png" height="20px" title="delete" width="20px" alt="close" class="borderradius20 my-auto mr-3 pointer p-1 backgroundcolorgray" @click="deleteSavedLink(savedlink, index)">
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-body bodymodal11" v-if="addingNewLink">
          <div class="pt-3 pb-3">
            <div class="opacityfont-12" >
              <div class="fontsize12 red proximanova mx-auto text-center mt-2" v-if="duplicateLinkError">Multiple links for same domain are not allowed.</div>
              <div class="fontsize12 red proximanova mx-auto text-center mt-2" v-if="selectedUserLinkValidatorError">Please add valid user link based on selected domain from dropdown</div>
                <div class="col-12 pl-0 pr-0 d-flex justify-content-between">
                  <div class="col-3 pr-0 pr-md-2">
                    <button type="button" id="togglebutton" class="btn col-12 pl-0 pr-0 btn-default border borderradius20 proximanova mt-3 editbtn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span v-if="!selectedWebsite">Select</span>
                      <span v-else><img :src="selectedWebsiteImage"  width="25px" alt=""></span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right dropdownlinks mx-auto borderradius20">
                      <span  class="p-1" v-for="(domain,index) in domainNamesList" :key="index"  @click="selectedWebsiteToAddLink(domain)">
                        <img :src="require('../assets/userlinks_'+domain.userDomain+'.svg')" :title="domain.userDomain" width="25px" alt="userlinks" class="mx-auto">
                      </span>
                    </div>
                  </div>
                  <div class="col-9 pl-0">
                  <input type="text" class="newbadge col-12 ml-2 p-2 fontsize14 mt-3 borderradius20 borderblack60" 
                  @keyup="userLinkValidationsBasedOnDomain" 
                  v-model="LinkSearchText"
                  :disabled="!selectedWebsite"
                  placeholder="eg : http://www.example.com">
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
            <button class="backgroundcolor3 proximanova-semibold border-0 white col-12 mx-auto p-2 borderradius20 fontsize14 col-10 mx-auto mouseoverbtn2" v-if="!addingNewLink" @click="close('NOTSUCCESS')">Done</button>
            <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid mx-auto ml-1" alt="uploadvideo" v-if="addingNewLink && saveLinkBtnClicked">
            <button class="backgroundcolor3 proximanova-semibold border-0 white col-12 mx-auto p-2 borderradius20 fontsize14 col-10 mx-auto mouseoverbtn2" :disabled="LinkSearchText.length < 10 || duplicateLinkError || selectedUserLinkValidatorError" v-if="addingNewLink && !saveLinkBtnClicked" @click="AddNewLink">Save</button>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mt-4 p-1 borderradius20 mouseoverbtn2" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      profileId : null,
      displayAPIerrorModal : false,
      domainNamesList : [],
      selectedWebsite : null,
      selectedWebsiteImage : null,
      selectedWebsiteDomain : null,
      selectedLinksToSave : [],
      //adding new link
      duplicateLinkError : false,
      selectedUserLinkValidatorError : false,
      addingNewLink : false,
      saveLinkBtnClicked : false,
      LinkSearchText : '',
      createNewBadgeSection : false,
    }
  },
  props : [
      'userLinksList'
  ],
  methods:{
    getDomainNamesList : function() {
      httpuserprofile.get("/userprofile/getUserLinksDomain")
      .then((response) => {
        console.log("domain list : ", response)
        this.domainNamesList = response.data
      }).catch((e) => {
        console.log(e)
      })
    },
    selectedWebsiteToAddLink : function(domain) {
      this.selectedWebsite = domain.userDomainId;
      this.selectedWebsiteDomain = domain.userDomain;
      this.selectedWebsiteImage = require('../assets/userlinks_'+domain.userDomain+'.svg')
      this.userLinkValidationsBasedOnDomain()
      console.log("check : ", this.selectedWebsite)
      this.duplicateLinkError = false;
      httpuserprofile.get("/userprofile/checkUserExistingDomain?userProfileId="+this.profileId+'&linkId='+this.selectedWebsite)
      .then((response) => {
        console.log("check domain link already added or not : ", response)
        if(response.data && response.data.message && response.data.message=='already existing domain'){
          this.duplicateLinkError = true
        }else{
          this.duplicateLinkError = false;
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    deleteSavedLink : function(link, index) {
      console.log("link : ", index, link)
      var vm = this;
      httpuserprofile.delete("/userprofile/deleteUserLinks?UserLinksId="+ link.userLinks.userLinksId)
      .then((response) => {
        console.log("delete user link list : ", response)
        this.userLinksList.splice(index, 1)
        console.log("userlinklist : ", this.userLinksList)
        vm.$toast.success("Link deleted successfully")
      }).catch((e) => {
        console.log(e)
      })
    },
    AddNewBadge : function() {
        this.addingNewLink = true;
    },
    NavigateToBack : function() {
      if(this.addingNewLink){
        this.addingNewLink = false;
        this.duplicateLinkError = false;
        this.selectedUserLinkValidatorError = false;
        this.selectedWebsite = null;
        this.selectedWebsiteDomain = null;
        this.LinkSearchText = ''
      }else{
        this.close('NOTSUCCESS')
      }
    },
    close(type) {
        this.$emit('closebadgemodal', type);
    },
    // user link validations
    userLinkValidationsBasedOnDomain : function() {
      console.log("link search text : ", this.LinkSearchText)
      console.log("git regex : " , this.LinkSearchText.includes(this.selectedWebsiteDomain))
      if(this.selectedWebsiteDomain && this.LinkSearchText.length > 3){
      if(this.LinkSearchText.includes(this.selectedWebsiteDomain)){
        this.selectedUserLinkValidatorError = false;
      }else{
        this.selectedUserLinkValidatorError = true;
      }
      }
    },
    //add links into final list
    // clear selected data data
    AddNewLink : function() {
      if(this.LinkSearchText.length > 3 && !this.duplicateLinkError){
        let obj = {
          userProfileId : this.profileId,
          linkId : this.selectedWebsite,
          url : this.LinkSearchText,
          seq : null,
          creationUserI : sessionUtils.getUserEmail(),
          updatedD : null,
          updatedUserI : sessionUtils.getUserEmail()
        }
        this.selectedLinksToSave.push(obj)
        this.selectedWebsite = null;
        this.selectedWebsiteDomain = null;
        this.selectedWebsiteImage = null;
        this.LinkSearchText = ''
        //new changes for individual saving
        this.SubmitNewBadges()
      }
    },
    SubmitNewBadges : function() {
      console.log("add new badges : ", this.selectedLinksToSave)
      var vm = this;
      this.saveLinkBtnClicked = true;
      let obj = this.selectedLinksToSave;
      httpuserprofile.post('/userprofile/saveUserLinks', obj)
      .then(response => {    
        console.log("save user links : ", response)
        let savedData = response.data;
        if(savedData && savedData.length > 0){
          for(var i =0; i<savedData.length; i++){
          this.userLinksList.push(savedData[i])
          }
        }
        vm.$toast.success("Links added successfully")
        this.clearSelectedData()
      }).catch(error=>{   
        console.log(error);  
        this.saveLinkBtnClicked = false;
      }) 
    },
    clearSelectedData : function() {
      this.selectedLinksToSave = [];
      this.addingNewLink = false;
      this.saveLinkBtnClicked = false;
    },
    moveToCreateBadgeSection : function() {
      this.createNewBadgeSection = true;
      this.duplicateLinkError = false;
    },
    
  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    console.log(this.userLinksList)
    this.getDomainNamesList()
  },

}

</script>

<style scoped>
@import '../css/modal.css';
</style>